module.exports = __webpack_public_path__ + "img/violet_048.21753c96.png";